// styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    line-height: 1.6;
    color: #e2e8f0;
    background-color: #000000;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    scroll-behavior: smooth;
    background: #000000;
  }

  section {
    padding: 5rem 2rem;
    position: relative;
    background: #000000;
    
    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
      padding: 3rem 1rem;
    }
  }

  .container {
    max-width: 1350px;
    margin: 0 auto;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 1rem;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.7;
    color: #cbd5e1;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #1a202c;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, ${props => props.theme.colors.primary} 0%, ${props => props.theme.colors.accent} 100%);
    border-radius: 6px;
    border: 2px solid #1a202c;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, ${props => props.theme.colors.accent} 0%, ${props => props.theme.colors.primary} 100%);
  }

  /* Selection styles */
  ::selection {
    background: ${props => props.theme.colors.primary};
    color: #000000;
  }

  /* Focus styles for accessibility */
  *:focus {
    outline: 2px solid ${props => props.theme.colors.primary};
    outline-offset: 2px;
  }

  /* Smooth transitions for all interactive elements */
  a, button, .interactive {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* 3D perspective classes */
  .perspective-1000 {
    perspective: 1000px;
  }

  .preserve-3d {
    transform-style: preserve-3d;
  }

  /* Loading animation for initial page load */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .page-load-animation {
    animation: fadeInUp 0.8s ease-out;
  }

  /* Gradient text utility */
  .gradient-text {
    background: linear-gradient(135deg, ${props => props.theme.colors.primary} 0%, ${props => props.theme.colors.accent} 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  /* Glass morphism effect */
  .glass {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  /* Floating animation */
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  .floating {
    animation: float 3s ease-in-out infinite;
  }

  /* Pulse animation */
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  .pulse {
    animation: pulse 2s ease-in-out infinite;
  }

  /* Prevent FOUC (Flash of Unstyled Content) */
  .js-loading *,
  .js-loading *:before,
  .js-loading *:after {
    animation-play-state: paused !important;
  }

  /* Improved image rendering */
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Better list styles */
  ul, ol {
    margin-bottom: 1rem;
    padding-left: 2rem;
  }

  li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
    color: #cbd5e1;
  }

  /* Form element improvements */
  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    border: 1px solid #4a5568;
    border-radius: 0.5rem;
    padding: 0.75rem;
    width: 100%;
    background: #1a202c;
    color: #e2e8f0;
    transition: all 0.3s ease;

    &:focus {
      border-color: ${props => props.theme.colors.primary};
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
      background: #2d3748;
    }

    &::placeholder {
      color: #718096;
    }
  }

  /* Button base styles */
  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  /* Card styles for dark theme */
  .card {
    background: #1a202c;
    border: 1px solid #2d3748;
    border-radius: 0.75rem;
    padding: 1.5rem;
    transition: all 0.3s ease;

    &:hover {
      border-color: #4a5568;
      transform: translateY(-2px);
    }
  }

  /* Print styles */
  @media print {
    * {
      background: transparent !important;
      color: black !important;
      box-shadow: none !important;
      text-shadow: none !important;
    }
    
    body {
      font-size: 12pt;
      line-height: 1.4;
      background: white !important;
    }
    
    a, a:visited {
      text-decoration: underline;
    }
    
    .no-print {
      display: none !important;
    }
  }
`;

export default GlobalStyles;